import { Form, Tag, Modal, Button } from 'antd';
import ContactsContext from '../../../contexts/data/ContactsContext';
import { useContext, useEffect } from 'react';
import { getInterestLevel } from '@leedpulse-monorepo/utils';
import { FormContainer } from '@leedpulse-monorepo/components';
import ScenariosContext from '../../../contexts/data/ScenariosContext';
import { getTagColor } from '../../../../core/utils/commonUtils';
import { CONTACTS_PAGE_PATH } from '../../../../presentation/pages/contacts/ContactsPage';
import { useNavigate } from 'react-router-dom';

interface ContactDetailsModalProps {
  contactId: string,
  visible: boolean,
  onCancel: () => void
}

const ContactDetailsModal: React.FC<ContactDetailsModalProps> = ({
  contactId,
  visible,
  onCancel
}) => {
  const navigate = useNavigate();
  const contactsContext = useContext(ContactsContext);
  const scenariosContext = useContext(ScenariosContext);

  // Lu directement depuis le contexte : la copie en state local n'apportait
  // rien et imposait un rendu de plus a chaque arrivee des scenarios.
  const scenarios = scenariosContext.allScenarios;

  useEffect(() => {
    contactsContext.fetchAndSelectById(contactId);
  }, [contactId]);

  useEffect(() => {
    if (scenariosContext.allScenarios.length === 0) {
      scenariosContext.fetchAll();
    }
  }, []);

  const selectedContact = contactsContext.selected;

  const getOwner = () => {
    return contactsContext.selectionOwners.find((owner) => owner.uid === selectedContact?.contact.owner);
  };

  return (
    <Modal
      title='Détail contact'
      open={visible}
      footer={null}
      width={750}
      onCancel={() => onCancel()}
    >
      <Form
        layout="vertical"
        initialValues={{ remember: true }}
        requiredMark={false}
      >
        <FormContainer oneColumnMax>
          <Form.Item>
            <Tag className='contact-tile__content__owner-tag'>
              {contactId}
            </Tag>
            <Tag className='contact-tile__content__owner-tag' color={getTagColor(selectedContact?.qualification_ai.qualification as string)}>
              &#8226; {getInterestLevel(selectedContact?.qualification_ai.qualification || "not_available")}
            </Tag>
            <Tag className='contact-tile__content__owner-tag' color='lightgray'>
              {scenarios.find(scenario => scenario.id === selectedContact?.contact.prospect_category)?.name || selectedContact?.contact.prospect_category}
            </Tag>
          </Form.Item>
        </FormContainer>
        <FormContainer twoColumnsMax>
          <Form.Item label="Prénom">
            {selectedContact?.contact.firstname}
          </Form.Item>
          <Form.Item label="Nom">
            {selectedContact?.contact.lastname}
          </Form.Item>
          <Form.Item label="Email">
            {selectedContact?.contact.email}
          </Form.Item>
          <Form.Item label="Téléphone">
            {selectedContact?.contact.phone}
          </Form.Item>
          <Form.Item label="Conseiller">
            {`${getOwner()?.firstname} ${getOwner()?.lastname}`}
          </Form.Item>
          <Form.Item label="N° d'envoyeur">
            {selectedContact?.contact.sender}
          </Form.Item>
        </FormContainer>
        <FormContainer oneColumnMax>
          <Form.Item label="Détails">
            {selectedContact?.contact.details}
          </Form.Item>
        </FormContainer>
        <div className="contact-details-modal__link" style={{ display: 'flex', justifyContent: 'center' }}>
          <Button color="default" type="link" onClick={() => navigate(`${CONTACTS_PAGE_PATH}/${contactId}`)}>
            Voir toute la fiche
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ContactDetailsModal;
